import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(public auth: AuthService, public router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    // console.log('🛡️ AuthGuard canActivate called for route:', state.url);

    // Use the async authentication check to ensure auth service is properly initialized
    return this.auth.isAuthenticatedAsync().then(isAuthenticated => {
      // console.log('🛡️ AuthGuard authentication result:', {
      //   isAuthenticated,
      //   route: state.url,
      //   timestamp: new Date().toISOString()
      // });

      if (!isAuthenticated) {
        // console.log('🛡️ AuthGuard: User not authenticated, redirecting to login');
        // Store the intended URL
        localStorage.setItem("fromExternalUrl", state.url.replace('/', ''));
        this.router.navigate(['login']);
        return false;
      }

      // console.log('🛡️ AuthGuard: User authenticated, allowing access to route');
      return true;
    }).catch(error => {
      console.error('❌ AuthGuard: Error during authentication check:', error);
      // console.log('🛡️ AuthGuard: Error occurred, redirecting to login as fallback');
      // On error, redirect to login as a safe fallback
      localStorage.setItem("fromExternalUrl", state.url.replace('/', ''));
      this.router.navigate(['login']);
      return false;
    });
  }
}
